export default function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-format@1.4.5@d3-format/src/formatNumerals.js
// module id = null
// module chunks = 